import React, { useState } from "react";

// Data
import { navLinksMobile } from "utils/constants/data";

// Icons
import CloseIcon from "assets/icons/general/CloseIcon";
import KeyboardArrowDownIcon from "assets/icons/general/KeyboardArrowDownIcon";

function Menu({ className, setMenuOpen }) {
  const [dropdownOpen, setDropdownOpen] = useState(null);

  return (
    <div
      className={`${className} fixed top-0 bottom-0 left-0 right-0 flex flex-col xl:hidden bg-interlink-white gap-4 px-4 py-4 transition-all duration-300`}
    >
      <div className="flex justify-end mb-8">
        <button onClick={() => setMenuOpen(false)}>
          <CloseIcon className="h-10 w-10 fill-interlink-dark-grey" />
        </button>
      </div>
      <ul className="flex flex-col justify-center gap-8 sm:gap-10">
        {navLinksMobile.map((item, i) => (
          <li key={i}>
            <a
              href={item?.path}
              className={`flex text-base md:text-xl font-semibold items-center gap-2 cursor-pointer select-none w-fit ${
                window.location.pathname === item.path
                  ? "border-b text-interlink-blue border-interlink-blue pb-1 -mb-1"
                  : "text-interlink-dark-grey border-b border-transparent pb-1 -mb-1"
              }`}
              onClick={() => {
                setDropdownOpen((prev) => (prev === i ? null : i));
              }}
            >
              {item.label}
              {item.dropdownItems?.length > 0 && (
                <KeyboardArrowDownIcon
                  className={`h-6 w-5 fill-interlink-dark-grey ${
                    dropdownOpen === i ? "rotate-180" : "rotate-0"
                  } transition-all duration-300`}
                />
              )}
            </a>
            {dropdownOpen === i && navLinksMobile?.[i]?.dropdownItems && (
              <div className="mt-2 space-y-4 pt-4">
                {navLinksMobile?.[dropdownOpen]?.dropdownItems?.map(
                  (item, i) => {
                    return (
                      <a
                        key={i}
                        href={`${item.path}`}
                        className="flex text-sm md:text-base font-semibold select-none space-x-4"
                      >
                        <p className="font-semibold text-interlink-blue">
                          {item.label}
                        </p>
                      </a>
                    );
                  }
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Menu;
